import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

const PublicRoute = ({ component: Component, isLoggedIn, ...rest }) => (
    <Route
        render={(props) => {

            if (!isLoggedIn) {
                return <Component {...props} />
            } else {
                return <Redirect to={`/`} />

            }
        }}
        {...rest}
    />
)

PublicRoute.propTypes = {
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
    isLoggedIn: state.Auth.isLoggedIn,
})

export default connect(mapStateToProps)(PublicRoute)
